/**
 * Severidade no domínio do banco (0 a 3), usado pelo módulo de gestão.
 * Não confundir com o de 1 a 4 exposto pelos endpoints do kanban, que tem
 * helper próprio em utils/chamadoUtils.
 */
export const SEVERIDADES_GESTAO = [0, 1, 2, 3] as const;

export const rotuloSeveridade = (severidade: number): string =>
  ({ 0: "Crítica", 1: "Alta", 2: "Média", 3: "Baixa" }[severidade] ??
  "Não definida");

export const classesSeveridade = (severidade: number): string =>
  ({
    0: "bg-red-100 text-red-800 border-red-200",
    1: "bg-orange-100 text-orange-800 border-orange-200",
    2: "bg-yellow-100 text-yellow-800 border-yellow-200",
    3: "bg-green-100 text-green-800 border-green-200",
  }[severidade] ?? "bg-gray-100 text-gray-700 border-gray-200");

export const formatarTamanho = (bytes: number): string => {
  if (bytes <= 0) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

export const formatarData = (valor: string | null, comHora = false): string => {
  if (!valor) return "—";
  const data = new Date(valor);
  if (Number.isNaN(data.getTime())) return "—";
  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(comHora ? { hour: "2-digit", minute: "2-digit" } : {}),
  });
};

/** Cor sólida da severidade, para o ponto do grupo e a borda do card. */
export const pontoSeveridade = (severidade: number): string =>
  ({ 0: "bg-red-500", 1: "bg-orange-500", 2: "bg-yellow-500", 3: "bg-emerald-500" }[
    severidade
  ] ?? "bg-gray-400");

export const bordaSeveridade = (severidade: number): string =>
  ({
    0: "border-l-red-500",
    1: "border-l-orange-500",
    2: "border-l-yellow-500",
    3: "border-l-emerald-500",
  }[severidade] ?? "border-l-gray-300");
